$(function() {
    const inputs = $("form input:password");
    
    inputs.each((i, input) => {
        input = $(input);
        input.wrap($("<div>").addClass("input-group"));
        input.after(
            $("<button>").addClass("btn btn-sm btn-outline-secondary").attr({
                "type": "button",
                "id": "showPassword",
                "tabindex": "-1"
            })
        );
    });

    $("form .input-group #showPassword").each(function() {
        const openEye = $("<i>").addClass("bi-eye");
        const slashedEye = $("<i>").addClass("bi-eye-slash");
        const togglePasswordBtn = $(this);

        togglePasswordBtn.append(openEye);

        togglePasswordBtn.on("click", event => {
            const currentTarget = $(event.currentTarget);
            const input = currentTarget.closest(".input-group").find("input");
            if (input.attr("type") === "password") {
                currentTarget.empty().append(slashedEye);
                input.attr("type", "text");
            }else{
                currentTarget.empty().append(openEye);
                input.attr("type", "password");
            }
        });
    });
});